export default "__VITE_ASSET__Yqi_fXg5__"